<template>
  <div>
    <div
      v-if="!connectionReady"
      style="min-height: 60px"
      class="container d-flex justify-content-center"
    >
      <b-spinner large variant="primary" />
    </div>
    <WinbackView v-else />
  </div>
</template>

<script>
import WinbackView from '@/components/Modules/Winback/WinbackView.vue'
import { createNamespacedHelpers } from 'vuex'

const WebsocketModuleV2 = createNamespacedHelpers('websocketV2')

export default {
  name: 'WinbackNewAllCompaniesView',
  components: {
    WinbackView,
  },
  computed: {
    ...WebsocketModuleV2.mapGetters(['selectConnectionReady']),
    connectionReady() {
      return this.selectConnectionReady
    },
  },
  methods: {
    ...WebsocketModuleV2.mapActions([
      'winbackV2ConversationsAllCompaniesPresenceSubscribe',
      'winbackV2ConversationsAllCompaniesPresenceUnsubscribe'
    ])
  },
  watch: {
    connectionReady: {
      immediate: true,
      handler(ready) {
        if (ready) {
          this.winbackV2ConversationsAllCompaniesPresenceSubscribe()
        }
      }
    }
  },
  beforeDestroy() {
    this.winbackV2ConversationsAllCompaniesPresenceUnsubscribe()
  }
}
</script>

<style scoped lang="scss"></style>
